import React, { FunctionComponent, useState } from "react";
import {
  Fab,
  Button,
  Grid,
  Table,
  Dialog,
  MuiThemeProvider,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import Switch from "@material-ui/core/Switch";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import Tooltip from "@material-ui/core/Tooltip";
import MUIDataTable from "mui-datatables";
import { useStore } from "../../../store";
import { SnackBar } from "../../SnackBar";
import { useTableStyles } from "../../useTableStyle";
import { useDivisionStyles } from "../useDivisionStyles";
import { ThemeProvider } from "@mui/material/styles";

const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const columns = [
  "Name",
  "Code",
  ""
];

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

type DivisiontProps = {
  editDivisionPermission: boolean;
};

export const DivisionTableList: FunctionComponent<DivisiontProps> = ({
  editDivisionPermission
}) => {
  const classes = useDivisionStyles();
  const getMuiTheme = useTableStyles();
  const [division, {getDivision, updateDivision}] = useStore("division");
  const [status] = useStore("status");
  const [divId, setDivId] = useState<number>();
  const [divtName, setDivName] = useState<string>("");
  const [divStatus, setDivStatus] = useState<number>(0);
  const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [departmentStatus, setDepartmentStatus] = useState<string>("");
  

  const handleChange = (id: number, status_id: number, name: string) => {
    const inactiveId =
      status &&
      status.find((i: any) => i.description === "Inactive").id;
    setDivName(name);
    setDivStatus(status_id===null?inactiveId:status_id);
    setDivId(id);
    setOpenConfirmation(true);
  };

  const changeStatus = async (div_status: number) => {
    try {
      const status_description =
      status &&
      status.find((i: any) => i.id === div_status).description === "Active" ? "Inactive" : "Active";
      const statusId =
        status &&
        status.find((i: any) => i.description === status_description).id;

      const values = {
        status: statusId,
      };
      console.log("values...",values,divId)
      const result = await updateDivision(divId, values);
      console.log("result...",result)

      if (result !== undefined) {
        setOpenConfirmation(false);
        setSnackbarColor("green");
        setDepartmentStatus("Status updated successfully");
        await getDivision();
      }
    } catch (error:any) {
      console.log(error);
      setSnackbarColor("red");
      setDepartmentStatus(error.error);
    }
  };

  const onCloseSnackbar = () => {
    setDepartmentStatus("");
  };

  if (division && division.length > 0) {
    return (
      <div className={classes.root1}>
        <SnackBar
          status={departmentStatus}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Division List"}
              data={ division&& division.map((div: any) => {
                return [
                    div.name,
                    div.code,
                  <Grid container direction="row" spacing={2} justify="flex-end"
                    style={{ display: editDivisionPermission ? "" : "none" }}
                  >
                    <Grid item>
                      <Tooltip
                        title={ 
                            status&&status.find((i:any)=>i.id===div.status)!==undefined?(
                                status&&status.find((i:any)=>i.id===div.status).description=== "Active"
                                ? "Change status to Inactive"
                                : "Change status to Active"
                            ):""}>
                        <Switch
                          checked={
                            status&&status.find((i:any)=>i.id===div.status)!==undefined?(
                                status&&status.find((i:any)=>i.id===div.status).description=== "Active" ? true : false
                            ):false}
                          onChange={() =>
                            handleChange(
                              div.id,
                              div.status,
                              div.name
                            )
                          }
                          style={{color:div.status === "Active"?"#3d5a79": undefined}}
                          color="primary"
                          name="status"
                          inputProps={{ "aria-label": "primary checkbox" }}   
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                ];
              })
            }
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Table>
        <Dialog
          open={openConfirmation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {status&&status.find((i:any)=>i.id===divStatus) !==undefined?(
                  status&&status.find((i:any)=>i.id===divStatus).description=== "Active"
                  ? `Would you like to change status of ${divtName} to Inactive?`
                  : `Would you like to change status of ${divtName} to Active?`
              ):""}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button 
            onClick={() => changeStatus(divStatus)} 
            id="buton">
              Yes
          </Button>
            <Button
              onClick={() => setOpenConfirmation(false)}
              autoFocus
              id="buton"
            >
              No
          </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return (
      <div className={classes.root}>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Division List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};
